<template>
  <ValidationProvider :rules="rules" v-slot="{ errors, valid }" :name="errorLabelText" :vid="vid">
    <b-field
      :label="label"
      :type="{'is-danger': errors.length }"
      :message="errors[0]"
      custom-class="test-color"
    >
      <b-input
        v-model="content"
        :name="name"
        :type="type"
        :vid="vid"
        :password-reveal="passwordReveal"
        @input="updateData()"
      ></b-input>
    </b-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

/**
 * Custom Form input with validation setup
 */
export default {
  name: "FormInputWithValidation",
  props: {
    rules: { type: String, required: true },
    value: { type: String, required: true },
    label: { type: String, default: "" },
    vid: { type: String, default: "" },
    name: { type: String, required: true },
    errorLabel: { type: String },
    type: { type: String, default: "text" },
    passwordReveal: { type: Boolean, default: false }
  },

  components: {
    ValidationProvider
  },

  data() {
    return {
      content: this.value
    };
  },

  computed: {
    /**
     * Determine the text to be used as the field name when displaying error messages
     */
    errorLabelText() {
      if (this.errorLabel) {
        return this.errorLabel;
      }

      return this.name;
    }
  },

  methods: {
    updateData: function() {
      this.$emit("input", this.content);
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.content = val;
      }
    }
  }
};
</script>



